<script setup lang="ts">
interface Props {
  currentStep: number
  title?: string
}

withDefaults(defineProps<Props>(), {
  title: undefined,
})

const emits = defineEmits<{
  prevStep: []
  close: []
}>()
</script>

<template>
  <header class="sticky top-0 z-10 flex justify-between bg-white px-4 sm:px-10 py-4">
    <button
      :class="{ 'text-transparent': currentStep === 0 }"
      class="shrink-0 py-0.5 pr-0.5 md:pl-0.5 md:pr-0"
      @click="emits('prevStep')"
    >
      <YscIconsArrowLeft class="h-6 w-6" />
    </button>

    <h2
      v-if="title"
      class="grow font-semibold text-center text-2xl"
    >
      {{ title }}
    </h2>

    <button
      class="shrink-0 py-0.5 pr-0.5 md:pl-0.5 md:pr-0"
      @click="emits('close')"
    >
      <YscIconsDelete class="h-6 w-6" />
    </button>
  </header>
</template>
